/* unplugin-vue-components disabled */import { render } from "./icon_home.vue?vue&type=template&id=47850ad0&scoped=true"
const script = {}

import "./icon_home.vue?vue&type=style&index=0&id=47850ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47850ad0"]])

export default __exports__